/***
 * @file:è®¾ç½®å­å¨é¡¹
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Injectable, Injector } from '@angular/core';
import { isEmpty } from 'lodash';
import { Observable, Subject } from 'rxjs';

import { Layout, SettingsNotify, User } from './setting.interface';
import { StoreService } from './store.service';
import { MenuData, PageData, Pages } from './theme.interface'; // åé¢æ¹ä¸ºä»themeä¸é¢å¼ç¨
// import { WaterMarkService } from './water-mark.service';

const LAYOUT_KEY = 'layout';
const USER_KEY = 'user';
const MENU_KEY = 'menu';
const SELECTED_MENU = 'selectedMenu';
const PAGES_KEY = 'pages';
const COLLECTION_KEY = 'collection';
const TOKEN_KEY = 'token';
const PERMISSIONS_KEY = 'permissions';
const VISIT_KEY = 'visit';
const MODELIDS_KEY = 'modelIds';
// ç¨æ·éç½®
const USER_CONFIG = 'userConfig';
const HIDEMENU_KEY = 'hideMenu'; // è¿ä¸ªä¸»è¦ç¨äºæ¬å°settionç¼å­
const REDIRECT_URL_KEY = 'redirectUrl';

/**
 * @desc è®¾ç½®é¡¹çå­å¨
 * Q: ä¸ºä½åºåï¼
 * A: æçæ°æ®å¨é¡µé¢å³é­åºéæ¯ï¼æçæ°æ®åºé¿æå­å¨ã
 *
 * 1) é¿æå­å¨
 *    1.1 å¸å±: layout
 *    1.2 æ¶èçé¡µé¢: collectedPage -- æ ¹æ®ç¨æ·å­å¨ï¼é¿åè¶æ
 *
 * 2ï¼ä¼è¯ç»æéæ¯çå­å¨
 *    2.1 ç¨æ·å­è¯: token
 *    2.2 ç¨æ·ä¿¡æ¯: user
 *    2.3 ç¨æ·èå: menu
 *    2.4 æå¼çé¡µé¢: pages
 *    2.5 éä¸­çé¡µé¢: selectedPage
 *    2.6 æéä¿¡æ¯: permissions
 */
@Injectable({ providedIn: 'root' })
export class SettingsService {
  private notify$ = new Subject<SettingsNotify>();
  private _user: User = null;
  private _layout: Layout = null;
  private _menu: MenuData[] = null;
  private _selectedMenu;
  private _token: string = null;
  private _permissions: any[] = [];
  private _visit: string[] = [];
  private _config: any;
  private _modelIds: string[];
  private _hideMenu: number; // 0ï¼æ¾ç¤ºã 1ï¼éè
  private _redirectUrl: string; // ç´æ¥æå¼æä¸ªé¡µé¢ï¼åç°æªç»éï¼ä¹åç»ééå®åå°æå¼çé¡µé¢ã

  // protected waterMarkSrv: WaterMarkService; // ç§æ·æå¡

  constructor(public storeSrv: StoreService) {
    // this.waterMarkSrv = this.inj.get(WaterMarkService);
  }

  get aa() {
    return '123';
  }
  // å¸å±éç½®ä¿¡æ¯
  get layout(): Layout {
    // å¦ææ²¡æéç½®ä¿¡æ¯åä»ç¼å­éé¢è¯»åå¹¶èµäºé»è®¤å¼
    if (!this._layout) {
      this._layout = Object.assign(
        {
          fixed: false,
          collapsed: false,
          top: false,
        } as Layout,
        this.storeSrv.get(LAYOUT_KEY, true)
      );
      this.storeSrv.set(LAYOUT_KEY, this._layout, true);
    }
    return this._layout;
  }

  // ç¨æ·ä¿¡æ¯
  get user(): User {
    if (!this._user) {
      this._user = Object.assign({} as User, this.storeSrv.get(USER_KEY));
      this.storeSrv.set(USER_KEY, this._user);
    }
    // this.waterMarkSrv.initwaterMark(this.userConfig, this._user);
    return this._user || {};
  }

  // tokenä¿¡æ¯
  get token(): string {
    if (!this._token) {
      this._token = this.storeSrv.get(TOKEN_KEY, true) || '';
    }
    // this.waterMarkSrv.initwaterMark(this.userConfig, this.user);
    return this._token;
  }

  // èåæ°æ®
  get menu(): MenuData[] {
    if (!this._menu) {
      this._menu = this.storeSrv.get(MENU_KEY) || [];
    }
    return this._menu;
  }

  // tabåæ¢èå
  get pages(): Pages {
    let p = this.storeSrv.get(PAGES_KEY);
    if (isEmpty(p)) {
      p = {
        data: [],
        index: null,
      };
    }
    return p;
  }

  // æ¶èçèå
  get collection(): PageData[] {
    let c = this.storeSrv.get(this.collectionKey, true);
    if (isEmpty(c)) {
      c = [];
    }
    return c;
  }

  // éä¸­çèå
  get selectedMenu() {
    if (isEmpty(this._selectedMenu)) {
      this._selectedMenu = this.storeSrv.get(SELECTED_MENU) || {};
    }
    return this._selectedMenu;
  }

  // æéä¿¡æ¯
  get permissions(): any[] {
    const storeSrvd = this.storeSrv.get(PERMISSIONS_KEY);
    if (isEmpty(this._permissions)) {
      storeSrvd ? (this._permissions = storeSrvd) : (this._permissions = [{ router: '', opreations: [''] }]);
    }
    return this._permissions;
  }

  // æéä¿¡æ¯
  get modelIds(): string[] {
    const storeSrvd = this.storeSrv.get(MODELIDS_KEY);
    if (isEmpty(this._modelIds)) {
      storeSrvd ? (this._modelIds = storeSrvd) : (this._modelIds = ['']);
    }
    return this._modelIds;
  }

  // å¯è®¿é®çè·¯ç±
  get visit(): string[] {
    if (isEmpty(this._visit)) {
      this._visit = this.storeSrv.get(VISIT_KEY);
    }
    return this._visit;
  }

  // è·åç¨æ·éç½®ä¿¡æ¯
  get userConfig() {
    if (isEmpty(this._config)) {
      this._config = this.storeSrv.get(USER_CONFIG);
    }
    return this._config;
  }

  // è·åå½åé¡µé¢æ¯å¦éè¦éèèå
  get hideMenu() {
    if (isEmpty(this._hideMenu)) {
      this._hideMenu = this.storeSrv.get(HIDEMENU_KEY);
    }
    return this._hideMenu;
  }

  // è·åå½åé¡µé¢æ¯å¦éè¦éèèå
  get redirectUrl() {
    if (isEmpty(this._redirectUrl)) {
      this._redirectUrl = this.storeSrv.get(REDIRECT_URL_KEY);
    }
    return this._redirectUrl;
  }

  // äºä»¶çå¬
  get notify(): Observable<SettingsNotify> {
    return this.notify$.asObservable();
  }

  // è®¾ç½®å¸å±
  setLayout(name: string, value: any): boolean {
    this.layout[name] = value;
    this.storeSrv.set(LAYOUT_KEY, this._layout, true);
    this.notify$.next({ type: 'layout', name, value });
    return true;
  }

  // å­å¨token
  setToken(value: string) {
    this._token = value;
    // ææ¶åæ¶å­å¨å¨Localstorageä¸­
    // this.storeSrv.set(TOKEN_KEY, value, true);
    this.storeSrv.set(TOKEN_KEY, value, true);
    this.notify$.next({ type: 'token', value });
    return true;
  }

  // è®¾ç½®ç¨æ·ä¿¡æ¯
  setUser(value: User) {
    this._user = value;
    this.storeSrv.set(USER_KEY, value);
    this.notify$.next({ type: 'user', value });
    // æ ¹æ®ç¨æ·ä¸åè¿è¡å­å¨æ¶èçèå
    return true;
  }

  // å­å¨èåæ°æ®
  setMenu(value: MenuData[]) {
    this._menu = value;
    this.storeSrv.set(MENU_KEY, value);
    return true;
  }

  // å­å¨éä¸­çèå
  setSelectedMenu(value: any): boolean {
    this._selectedMenu = value;
    this.storeSrv.set(SELECTED_MENU, value);
    this.notify$.next({ type: 'selectedMenu', value });
    return true;
  }

  // å­å¨æå¼çé¡µé¢æ°æ®
  setPages(value: Pages) {
    this.storeSrv.set(PAGES_KEY, value);
    return true;
  }

  // å­å¨æ¶èæ°æ®
  setCollection(value: PageData[]) {
    this.storeSrv.set(this.collectionKey, value, true);
    return true;
  }

  // å­å¨æé
  setPermissions(value: any[]) {
    this._permissions = value;
    this.storeSrv.set(PERMISSIONS_KEY, value);
    return true;
  }

  // å­å¨ModelIds
  setModelIds(value: string[]) {
    this._modelIds = value;
    this.storeSrv.set(MODELIDS_KEY, value);
    return true;
  }

  // å­å¨å¯è®¿é®çè·¯ç±
  setVisit(value: string[]) {
    this._visit = value;
    this.storeSrv.set(VISIT_KEY, value);
    this.notify$.next({ type: 'visit', value });
    return true;
  }

  // è®¾ç½®ç¨æ·éç½®ä¿¡æ¯
  setUserConfig(value: any): boolean {
    this.storeSrv.set(USER_CONFIG, value);
    return true;
  }

  // ä¿å­æ¯å¦éèèå
  setHideMenu(value: number): boolean {
    this.storeSrv.set(HIDEMENU_KEY, value);
    return true;
  }

  // ä¿å­æ¯å¦éèèå
  setRedirectUrl(value: string): boolean {
    this.storeSrv.set(REDIRECT_URL_KEY, value);
    return true;
  }

  // æ¸é¤èå
  cleanMenu() {
    this._menu = null;
    this.storeSrv.remove(MENU_KEY);
  }

  // æ¸é¤token
  cleanToken(value?: string): boolean {
    this._token = '';
    // ææ¶åæ¶å­å¨å¨Localstorageä¸­
    // this.storeSrv.remove(TOKEN_KEY, true);
    this.storeSrv.remove(TOKEN_KEY, true);
    this.notify$.next({ type: 'token', value });
    return true;
  }

  // æ¸é¤æå¼çé¡µé¢
  cleanPages() {
    this.storeSrv.remove(PAGES_KEY);
  }

  // æ¸é¤ç¨æ·
  cleanUser(value?: User) {
    this._user = {};
    this.storeSrv.remove(USER_KEY);
    this.notify$.next({ type: 'user', value });
  }

  // æ¸é¤éä¸­çèå
  cleanSelectedMenu(value?) {
    this._selectedMenu = {};
    this.storeSrv.remove(SELECTED_MENU);
    this.notify$.next({ type: 'selectedMenu', value });
    return true;
  }

  // æ¸é¤æéä¿¡æ¯
  cleanPermissions(value?: any) {
    this._permissions = [];
    this.storeSrv.remove(PERMISSIONS_KEY);
  }

  cleanModelIds() {
    this._modelIds = [];
    this.storeSrv.remove(MODELIDS_KEY);
  }

  // æ¸é¤å¯è®¿é®çè·¯ç±
  cleanVisit() {
    this._visit = null;
    this.storeSrv.remove(VISIT_KEY);
  }

  cleanRedirectUrl() {
    this._visit = null;
    this.storeSrv.remove(REDIRECT_URL_KEY);
  }

  // éç½®ç¼å­æ°æ® -- éåº
  resetSettings() {
    this.cleanToken();
    this.cleanUser();
    this.cleanMenu();
    this.cleanVisit();
    this.cleanPages();
    this.cleanSelectedMenu();
    this.cleanPermissions();
    this.cleanModelIds();
    this.resetTemp();
  }

  // éç½®åé
  resetTemp() {
    this._user = null;
    this._layout = null;
    this._menu = null;
    this._selectedMenu = '';
    this._token = null;
    this._permissions = [];
  }

  // è·å¾æ¶èèåå­å¨çkey
  get collectionKey(): string {
    return this.user.userId + '_' + COLLECTION_KEY;
  }
}
